/* ==========================================================================
   Product page · [data-boxhero] · [data-explode] · [data-sound]
   ========================================================================== */
(function () {
  "use strict";
  var W = window.Wango || {};
  var reduced = W.reduced ? W.reduced() : false;
  /* Phones: every animation follows the scroll (see Wango.mobile in wango-core). */
  var mobile = !!(W.mobile && W.mobile());
  function introDone() { if (W.introDone) W.introDone(); }

  /* ── box-reveal hero: centred stack easing into two columns ───────────────
     A hand-rolled FLIP, NOT Flip.from({ absolute: true }).

     `absolute: true` pulls both elements out of flow for the whole tween. The
     wrapper's height then collapses to 0, and the section (which centres its
     content) re-centres around nothing; on the last frame the elements return
     to flow and the video jumps ~112px straight up in a single frame. That
     was the "teleport" — measured by seeking the tween: the video's centre-y
     went 609 → 542 across 95% of the tween, then 542 → 430 on the final frame.

     Here the layout switches ONCE, instantly, to its final state; every
     element is then pulled back to where it visibly was with a transform and
     eased to rest. Nothing leaves the flow, so the wrapper never collapses and
     there is no frame at which anything jumps. The video rides a diagonal
     path (left and up); the copy rides the mirror path (right and down).
     Below md (and under reduced motion) the centred stack IS the permanent
     layout, so there is nothing to animate. */
  function centreOf(r) { return { x: r.left + r.width / 2, y: r.top + r.height / 2, w: r.width }; }

  /* In-page buttons glide through Lenis instead of jumping. */
  function initBoxHeroLinks(section) {
    section.querySelectorAll("[data-boxhero-go]").forEach(function (a) {
      a.addEventListener("click", function (e) {
        var hash = a.getAttribute("href") || "";
        if (hash.charAt(0) !== "#") return;
        var target = document.getElementById(hash.slice(1));
        if (!target) return;
        e.preventDefault();
        W.scrollTo(target);
      });
    });
  }

  function initBoxHero(section) {
    initBoxHeroLinks(section);
    var wrap = section.querySelector("[data-boxhero-wrap]");
    if (!wrap || reduced || !window.gsap) { introDone(); return; }
    /* The opening here is the reveal clip itself: it has finished once the clip
       has played through for the first time (with a ceiling, in case it never
       loads). */
    var clip = wrap.querySelector("video");
    if (clip) {
      /* timeupdate only fires about four times a second, so the last moments
         of a looping clip can be skipped over entirely: the jump back to the
         start counts as "finished" as well. */
      var lastTime = 0;
      var onTime = function () {
        var t = clip.currentTime;
        if ((clip.duration && t >= clip.duration - 0.5) || t < lastTime - 1) {
          clip.removeEventListener("timeupdate", onTime);
          introDone();
        }
        lastTime = t;
      };
      clip.addEventListener("timeupdate", onTime);
      setTimeout(introDone, 22000);
    } else {
      setTimeout(introDone, 4200);
    }
    if (!window.matchMedia("(min-width: 768px)").matches) return;
    var text = wrap.querySelector(".w-boxhero__text");
    var media = wrap.querySelector(".w-boxhero__media");
    var actions = wrap.querySelector(".w-boxhero__actions");
    var visual = media && media.firstElementChild;   /* the max-width box the eye actually sees */
    if (!text || !media || !visual) return;
    wrap.classList.add("is-intro");   /* buttons stay hidden until the split */

    setTimeout(function () {
      if (wrap.classList.contains("is-split")) return;
      gsap.killTweensOf([text, media]);

      var tFirst = centreOf(text.getBoundingClientRect());
      var vFirst = centreOf(visual.getBoundingClientRect());
      var aFirst = actions && centreOf(actions.getBoundingClientRect());

      wrap.classList.add("is-split");                   /* final layout, instantly */
      wrap.classList.remove("is-intro");

      var tLast = centreOf(text.getBoundingClientRect());
      var aLast = actions && centreOf(actions.getBoundingClientRect());
      var vLast = centreOf(visual.getBoundingClientRect());
      var mRect = media.getBoundingClientRect();
      var scale = vFirst.w / vLast.w;

      var EASE = "power2.inOut", DUR = 1.7;
      /* copy: translate only — scaling text would distort it */
      gsap.fromTo(text,
        { x: tFirst.x - tLast.x, y: tFirst.y - tLast.y },
        { x: 0, y: 0, duration: DUR, ease: EASE, clearProps: "transform" });
      if (actions) gsap.fromTo(actions,
        { x: aFirst.x - aLast.x, y: aFirst.y - aLast.y },
        { x: 0, y: 0, duration: DUR, ease: EASE, clearProps: "transform" });

      /* video: scale about the visual's own centre, so it neither drifts nor
         pops while it settles into the narrower column */
      gsap.fromTo(media,
        { x: vFirst.x - vLast.x, y: vFirst.y - vLast.y, scale: scale,
          transformOrigin: (vLast.x - mRect.left) + "px " + (vLast.y - mRect.top) + "px" },
        { x: 0, y: 0, scale: 1, duration: DUR, ease: EASE, clearProps: "transform,transformOrigin" });
    }, 2400); /* lets the intro settle first */
  }

  /* ── exploded view: video currentTime scrubbed off scroll ─────────────── */
  function initExplode(outer) {
    var video = outer.querySelector("video");
    var callouts = outer.querySelectorAll("[data-explode-callout]");
    if (!video) return;

    if (reduced) {
      // No scrub to tie to: land on the fully-exploded last frame and show
      // every callout rather than never revealing them.
      video.pause();
      video.addEventListener("loadedmetadata", function () { video.currentTime = video.duration || 0; }, { once: true });
      video.preload = "auto"; video.load();
      callouts.forEach(function (el) { el.style.opacity = 1; el.style.transform = "none"; });
      return;
    }
    if (!window.ScrollTrigger) return;

    video.pause();
    /* The metadata may ALREADY be loaded when this runs (cached clip, or a
       blob fallback that kept the original source): `loadedmetadata` then
       never fires again, and waiting for the event alone left the video on
       frame 0 while the callouts animated — the explode "not following the
       scroll". */
    var ready = video.readyState >= 1, target = 0;
    video.addEventListener("loadedmetadata", function () { ready = true; });
    if (window.Wango && Wango.videoFromBlob) (W.whenNear || function (e, f) { f(); })(outer, function () { Wango.videoFromBlob(video); });
    /* Dimmed, not hidden: the text column keeps its full height from the first
       frame, so it stays balanced against the card instead of the heading
       floating alone at the top. */
    gsap.set(callouts, { opacity: 0.22, y: 12 });
    /* One seek in flight at a time, started from the ticker: a seek per scroll
       event cancelled the previous one before a frame landed. */
    gsap.ticker.add(function () {
      if (!ready || !video.duration || video.seeking) return;
      if (Math.abs(video.currentTime - target) > 0.01) video.currentTime = target;
    });

    ScrollTrigger.create({
      trigger: outer, start: "top top", end: "bottom bottom", scrub: true,
      onUpdate: function (self) {
        var p = self.progress;
        // The first 62% drives the explode; the callouts then arrive one at a
        // time, the last finishing at 97% — the animation ends when the scroll
        // does, with no long finished-but-still-pinned tail.
        if (ready && video.duration) {
          target = gsap.utils.clamp(0, 1, p / 0.62) * video.duration;
        }
        // The callouts light up over the same 0-62% range as the explode, one
        // after another with a slight overlap: the first starts the instant the
        // shell starts to open, the last finishes as it finishes opening.
        var seg = 0.62 / callouts.length;
        callouts.forEach(function (el, i) {
          var inAmt = gsap.utils.clamp(0, 1, (p - i * seg * 0.8) / (seg * 1.2));
          gsap.set(el, { opacity: 0.22 + 0.78 * inAmt, y: 12 * (1 - inAmt) });
        });
      }
    });
  }

  /* ── sound filter ─────────────────────────────────────────────────────── */
  var EARBUD_X_PCT = 0.5, EARBUD_Y_PCT = 0.42, EARBUD_W = 130;

  function initSound(root) {
    var canvas = root.querySelector("canvas");
    var heading = root.querySelector("[data-sound-head]");
    var audioEl = root.querySelector("audio:not([data-sound-voice])");
    var voiceEl = root.querySelector("audio[data-sound-voice]");
    if (voiceEl && !voiceEl.getAttribute("src")) voiceEl = null;
    var button = root.querySelector("[data-sound-filter]");
    var muteBtn = root.querySelector("[data-sound-mute]");
    var outLabel = root.querySelector("[data-sound-outlabel]");
    if (!canvas || !heading) return;
    var ctx = canvas.getContext("2d");
    if (!ctx) return;

    var muted = false, filtered = false;
    if (heading) { heading.style.opacity = reduced ? 1 : 0; heading.style.transform = reduced ? "none" : "translateY(18px)"; }

    var w = 0, h = 0;
    function resize() {
      var rect = root.getBoundingClientRect();
      w = rect.width; h = rect.height;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr);
      canvas.style.width = w + "px"; canvas.style.height = h + "px";
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    resize();
    new ResizeObserver(resize).observe(root);

    /* The source PNG's "black" is a photographic near-black, not #000, so
       drawn straight onto the canvas it shows as a faint rectangle. Zeroing
       the alpha of every near-black pixel once removes the box regardless of
       the exact source black level. */
    var earbudCanvas = null;
    var earbud = new Image();
    earbud.crossOrigin = "anonymous";
    earbud.onload = function () {
      var off = document.createElement("canvas");
      off.width = earbud.naturalWidth; off.height = earbud.naturalHeight;
      var oc = off.getContext("2d");
      if (!oc) return;
      oc.drawImage(earbud, 0, 0);
      try {
        var frame = oc.getImageData(0, 0, off.width, off.height), d = frame.data, TH = 22;
        for (var p = 0; p < d.length; p += 4) if (d[p] < TH && d[p + 1] < TH && d[p + 2] < TH) d[p + 3] = 0;
        oc.putImageData(frame, 0, 0);
      } catch (e) { /* tainted canvas — draw it unkeyed rather than not at all */ }
      earbudCanvas = off;
    };
    if (root.dataset.earbud) earbud.src = root.dataset.earbud;

    /* Web Audio graph, created lazily on the first real user gesture. */
    /* The filter does not muffle the room: the crowd steps back (quieter, its
       rumble thinned) while one voice in it comes forward and stays clear. With
       no voice track set, only the crowd steps back. */
    var audioCtx = null, filterNode = null, gainNode = null, presence = null, voiceGain = null;
    /* A few dB, not a switch: the room stays audible, only its edge comes off. */
    var RAW_FREQ = 20, SOFT_FREQ = 140, RAW_GAIN = 0.5, SOFT_GAIN = voiceEl ? 0.24 : 0.28;
    var VOICE_RAW = 0.32, VOICE_SOFT = 0.5;
    function ensureGraph() {
      if (audioCtx || !audioEl) return;
      try {
        var AC = window.AudioContext || window.webkitAudioContext;
        audioCtx = new AC();
        var src = audioCtx.createMediaElementSource(audioEl);
        filterNode = audioCtx.createBiquadFilter();
        filterNode.type = "highpass"; filterNode.frequency.value = RAW_FREQ;
        gainNode = audioCtx.createGain(); gainNode.gain.value = filtered ? SOFT_GAIN : RAW_GAIN;
        src.connect(filterNode).connect(gainNode).connect(audioCtx.destination);
        audioEl.volume = 1;              /* the gain node sets the level from here on */
        if (voiceEl) {
          var vsrc = audioCtx.createMediaElementSource(voiceEl);
          presence = audioCtx.createBiquadFilter();
          presence.type = "peaking"; presence.frequency.value = 2800; presence.Q.value = 0.9; presence.gain.value = 0;
          voiceGain = audioCtx.createGain(); voiceGain.gain.value = filtered ? VOICE_SOFT : VOICE_RAW;
          vsrc.connect(presence).connect(voiceGain).connect(audioCtx.destination);
          voiceEl.volume = 1;
        }
      } catch (e) { /* no Web Audio — the plain <audio> still plays, unfiltered */ }
    }
    /* Creating the AudioContext costs a ~220 ms freeze, so scrolling in never
       builds it: the plain element plays at the raw level, and the graph is
       made only on the tap that needs the filter. (Scrolling in can only play
       sound once the page has had a tap at all; browsers block it before.) */
    function startAudio(fromGesture) {
      if (muted || !audioEl || !audioEl.getAttribute("src")) return;
      if (fromGesture) ensureGraph();
      if (audioCtx) audioCtx.resume().catch(function () {});
      else { audioEl.volume = RAW_GAIN; if (voiceEl) voiceEl.volume = VOICE_RAW; }
      audioEl.play().catch(function () {});
      if (voiceEl) voiceEl.play().catch(function () {});
    }
    function stopAudio() { if (audioEl) audioEl.pause(); if (voiceEl) voiceEl.pause(); }
    function ramp(param, to) {
      var now = audioCtx.currentTime;
      param.cancelScheduledValues(now);
      param.setValueAtTime(param.value, now);
      param.setTargetAtTime(to, now, 0.7);   /* eases in over ~2.5 s, no audible corner */
    }
    function rampFilter(on) {
      if (!audioCtx || !filterNode || !gainNode) {
        if (audioEl) audioEl.volume = on ? SOFT_GAIN : RAW_GAIN;   /* no Web Audio: levels only */
        if (voiceEl) voiceEl.volume = on ? VOICE_SOFT : VOICE_RAW;
        return;
      }
      ramp(filterNode.frequency, on ? SOFT_FREQ : RAW_FREQ);
      ramp(gainNode.gain, on ? SOFT_GAIN : RAW_GAIN);
      if (voiceGain) { ramp(voiceGain.gain, on ? VOICE_SOFT : VOICE_RAW); ramp(presence.gain, on ? 1.5 : 0); }
    }

    var reach = { v: 0 };
    /* Phones: the clean strand grows with the scroll through the section and
       the heading rises with it; the button only starts the sound (audio needs
       a tap, a scroll is not a gesture a browser accepts for it). */
    var scrubSound = mobile && !!window.ScrollTrigger;
    if (button) button.addEventListener("click", function () {
      startAudio(true); rampFilter(true);
      if (scrubSound) { finishFilter(); return; }
      if (window.gsap) {
        gsap.to(reach, { v: 1, duration: 1.8, ease: "power2.out" });
        gsap.to(button, { opacity: 0, duration: 0.5, ease: "power1.out", onComplete: finishFilter });
      } else { reach.v = 1; finishFilter(); }
    });
    if (scrubSound) {
      ScrollTrigger.create({
        trigger: root, start: "top 65%", end: "bottom bottom", scrub: true,
        onUpdate: function (self) {
          var p = self.progress, hp = gsap.utils.clamp(0, 1, p / 0.22);
          heading.style.opacity = hp;
          heading.style.transform = "translateY(" + (18 * (1 - hp)).toFixed(1) + "px)";
          reach.v = gsap.utils.clamp(0, 1, (p - 0.3) / 0.5);
        }
      });
    }
    function finishFilter() {
      filtered = true;
      if (button) { button.disabled = true; button.textContent = button.dataset.labelOn || button.textContent; }
      if (outLabel) outLabel.textContent = outLabel.dataset.labelOn || outLabel.textContent;
    }

    if (muteBtn) muteBtn.addEventListener("click", function () {
      muted = !muted;
      muteBtn.setAttribute("aria-pressed", String(muted));
      muteBtn.querySelectorAll("[data-mute-on]").forEach(function (n) { n.style.display = muted ? "" : "none"; });
      muteBtn.querySelectorAll("[data-mute-off]").forEach(function (n) { n.style.display = muted ? "none" : ""; });
      if (!audioEl) return;
      audioEl.muted = muted;
      if (voiceEl) voiceEl.muted = muted;
      // Muting must actually stop the sound, not just silence a running stream.
      if (muted) stopAudio();
      else {
        var r = root.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) startAudio();
      }
    });

    /* A fanned BUNDLE of thin parallel strands — "noisy" = many strands fanned
       wide with per-strand jitter; "filtered" = one clean strand, no fan.
       Real elapsed time feeds every sin(), so there is no loop point to jump at. */
    var STRANDS = 7;
    function strandParams(i) {
      var seed = i * 1.3713 + 0.4;
      return { freq: 7 + (i % 4) * 2.4 + Math.sin(seed) * 1.1, speed: 1.9 + (i % 3) * 0.55, phase: seed * 3.1, jitterAmp: 3 + (i % 4) * 1.6 };
    }
    function drawBundle(x0, x1, cy, t, strands, fan, fromLeft, reachFrac) {
      var span = x1 - x0, drawSpan = span * reachFrac;
      if (drawSpan <= 1) return;
      ctx.globalAlpha = Math.min(1, reachFrac / 0.12);
      var steps = Math.max(2, Math.round(drawSpan / 5));
      for (var s = 0; s < strands; s++) {
        var pr = strandParams(s);
        var strandT = strands > 1 ? s / (strands - 1) - 0.5 : 0;
        ctx.beginPath();
        for (var i = 0; i <= steps; i++) {
          var x = x0 + (drawSpan * i) / steps;
          var nx = (x - x0) / span;
          var converge = fromLeft ? 1 - nx : nx;
          var baseY = strandT * fan * converge;
          var wobble = Math.sin(nx * pr.freq + t * pr.speed + pr.phase) * (pr.jitterAmp * (0.4 + 0.6 * converge));
          var edgeFade = fromLeft
            ? Math.min(1, nx / 0.1) * Math.min(1, (1 - nx) / 0.04)
            : Math.min(1, (1 - nx) / 0.1) * Math.min(1, nx / 0.04);
          var py = cy + (baseY + wobble) * edgeFade;
          if (i === 0) ctx.moveTo(x, py); else ctx.lineTo(x, py);
        }
        ctx.stroke();
      }
      ctx.globalAlpha = 1;
    }

    var soundOn = false, soundLoop = false;
    function tick(tMs) {
      if (!reduced) {
        if (!soundOn) { soundLoop = false; return; }
        requestAnimationFrame(tick);
      }
      var t = tMs / 1000;
      ctx.fillStyle = "#000"; ctx.fillRect(0, 0, w, h);
      var cx = w * EARBUD_X_PCT, cy = h * EARBUD_Y_PCT;

      // Explicit same-colour zero-alpha stop — never the bare "transparent"
      // keyword, which fades toward black and leaves a visible ring.
      var glow = ctx.createRadialGradient(cx, cy, 0, cx, cy, EARBUD_W * 1.6);
      glow.addColorStop(0, "rgba(176,166,230,0.22)");
      glow.addColorStop(1, "rgba(176,166,230,0)");
      ctx.fillStyle = glow;
      ctx.fillRect(cx - EARBUD_W * 1.6, cy - EARBUD_W * 1.6, EARBUD_W * 3.2, EARBUD_W * 3.2);

      /* The glow is a wide faint stroke under the thin one. Canvas shadowBlur
         blurred the whole strand bundle on every frame and kept the GPU busy
         enough to drop frames across the section. */
      ctx.save();
      ctx.lineCap = "round"; ctx.lineJoin = "round";
      ctx.strokeStyle = "rgba(165,175,225,0.10)"; ctx.lineWidth = 5;
      drawBundle(0, cx - EARBUD_W * 0.5, cy, t, STRANDS, 52, true, 1);
      ctx.strokeStyle = "rgba(165,175,225,0.6)"; ctx.lineWidth = 1.1;
      drawBundle(0, cx - EARBUD_W * 0.5, cy, t, STRANDS, 52, true, 1);

      if (reach.v > 0.001) {
        ctx.strokeStyle = "rgba(205,198,255,0.16)"; ctx.lineWidth = 8;
        drawBundle(cx + EARBUD_W * 0.5, w, cy, t, 1, 0, false, reach.v);
        ctx.strokeStyle = "rgba(215,212,248,0.85)"; ctx.lineWidth = 1.5;
        drawBundle(cx + EARBUD_W * 0.5, w, cy, t, 1, 0, false, reach.v);
      }
      ctx.restore();

      if (earbudCanvas) {
        var iw = EARBUD_W, ih = iw * (earbudCanvas.height / earbudCanvas.width || 1.5);
        ctx.drawImage(earbudCanvas, cx - iw / 2, cy - ih / 2, iw, ih);
      }
    }
    if (reduced) { setTimeout(function () { tick(0); }, 300); }
    /* the strands animate only while the section is on screen */
    new IntersectionObserver(function (es) {
      soundOn = es[es.length - 1].isIntersecting;
      if (soundOn && !soundLoop && !reduced) { soundLoop = true; requestAnimationFrame(tick); }
    }, { rootMargin: "100px" }).observe(root);

    /* Hysteresis so a section sitting on the boundary can't stutter the track
       on and off: START at ≥50% visible, STOP only once fully gone. */
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      if (!e) return;
      if (e.intersectionRatio >= 0.5) {
        startAudio();
        if (scrubSound) { /* the heading follows the scroll */ }
        else if (!reduced && window.gsap) gsap.to(heading, { opacity: 1, y: 0, duration: 1, ease: "power2.out" });
        else { heading.style.opacity = 1; heading.style.transform = "none"; }
      } else if (!e.isIntersecting) {
        stopAudio();
      }
    }, { threshold: [0, 0.5] }).observe(root);

    // Audio in a background tab is the same problem as audio off-screen.
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) stopAudio();
      else {
        var r = root.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) startAudio();
      }
    });
  }

  /* ── scroll product reveal ("Origin dönüyor") ────────────────────────────
     Ported from ProductScrollReveal in lib/product-reveal.tsx. A tall outer
     wrapper + `position: sticky` on the stage gives "stays put while you
     scroll through it" in pure CSS, so GSAP never reparents a live node.
     ONE scroll progress value drives everything:
       1 · the eyebrow holds dead-centre, then lifts and blurs away
       2 · a circular scene-wipe grows from the centre
       3 · the title rises into that same centre spot
       4 · a spec divider scales in, then two tooltips rise at their own marks
       …while the case spins 4 full turns.
     Scroll only sets a TARGET; a rAF loop eases the model toward it with a
     frame-rate-independent factor, so the spin stays a continuous glide even
     when scroll events arrive coarsely. */
  function initScrollReveal(outer) {
    var root = outer.querySelector(".psr-root");
    var host = outer.querySelector("[data-psr-model]");
    if (!root || !host) return;
    var header1 = root.querySelector(".psr-header-1");
    var mask = root.querySelector(".psr-mask");
    var header2 = root.querySelector(".psr-header-2");
    var header2h = root.querySelector(".psr-header-2 h1");
    var dividers = root.querySelectorAll(".psr-divider");
    var revealGroups = [0, 1].map(function (i) {
      return root.querySelectorAll(".psr-tooltip:nth-child(" + (i + 1) + ") .psr-reveal");
    });

    /* No motion / no WebGL: a plain, fully-readable end state instead of a
       stage that never reveals anything. */
    function showStatic() {
      outer.style.height = "auto";
      root.style.position = "relative";
      root.style.height = "auto";
      root.style.minHeight = "0";
      if (header1) header1.style.display = "none";
      mask.style.clipPath = "none";
      mask.style.position = "relative";
      mask.style.padding = "4rem 0";
      host.style.display = "none";
      header2.style.position = "relative";
      header2.style.transform = "none";
      header2.style.opacity = 1; header2.style.visibility = "visible";
      dividers.forEach(function (d) { d.style.transform = "none"; });
      root.querySelectorAll(".psr-reveal").forEach(function (n) { n.style.transform = "none"; n.style.opacity = 1; n.style.visibility = "visible"; });
      var tips = mask.querySelector(".psr-tooltips");
      if (tips) { tips.style.position = "relative"; tips.style.bottom = "auto"; tips.style.marginTop = "2rem"; }
    }

    var vid = host.querySelector("video");
    var view = null;
    if (vid && !reduced) {
      vid.muted = true; vid.pause();
      /* Some hosts (Shopify's theme-dev proxy, plain static servers) answer
         without byte-range support, which leaves the video unseekable — every
         currentTime write snaps back to 0. A blob URL is always seekable. */
      var vsrc = vid.getAttribute("data-src");
      if (vsrc) {
        (W.whenNear || function (e, f) { f(); })(root, function () {
          fetch(vsrc).then(function (r) { return r.blob(); })
            .then(function (b) { vid.src = URL.createObjectURL(b); vid.load(); })
            .catch(function () { vid.src = vsrc; });
        });
      }
      var lastT = -1;
      view = {
        setSpin: function (rad) {
          /* one seek in flight: a new currentTime every frame cancelled the
             previous seek before its frame landed, and the decoder queue
             stalled the whole page for seconds on a fast scroll */
          if (!vid.duration || vid.readyState < 2 || vid.seeking) return;
          var t = Math.min(rad / (SPINS * Math.PI * 2), 1) * (vid.duration - 0.04);
          if (Math.abs(t - lastT) < 1 / 120) return;
          lastT = t; vid.currentTime = t;
        },
        render: function () {}
      };
    } else if (!reduced && window.WangoCase3D) {
      view = WangoCase3D.create(host);
    }
    if (!view) { showStatic(); return; }

    /* eyebrow: split into chars that rise once the section is reached */
    var h1 = header1 && header1.querySelector("h1");
    var charSpans = [];
    var split = null;
    if (h1 && window.SplitText) {
      try {
        gsap.registerPlugin(SplitText);
        split = SplitText.create(h1, { type: "chars", charsClass: "char" });
        split.chars.forEach(function (c) { c.innerHTML = "<span>" + c.innerHTML + "</span>"; });
        charSpans = h1.querySelectorAll(".char > span");
        gsap.set(charSpans, { yPercent: 110 });
        if (mobile) {
          /* phones: the letters rise with the scroll, one after another, as the
             stage comes up into view */
          var nChars = charSpans.length || 1;
          ScrollTrigger.create({
            trigger: root, start: "40% bottom", end: "95% bottom", scrub: true,
            onUpdate: function (self) {
              [].forEach.call(charSpans, function (c, i) {
                var t = gsap.utils.clamp(0, 1, self.progress * 1.6 - (i / nChars) * 0.6);
                c.style.transform = "translateY(" + (110 * (1 - t * (2 - t))).toFixed(1) + "%)";
              });
            }
          });
        } else {
          ScrollTrigger.create({
            trigger: root, start: "75% bottom",
            onEnter: function () { gsap.to(charSpans, { yPercent: 0, duration: 1, ease: "power3.out", stagger: 0.03 }); },
            onLeaveBack: function () { gsap.to(charSpans, { yPercent: 110, duration: 1, ease: "power3.out", stagger: 0.03 }); }
          });
        }
      } catch (e) { charSpans = []; }
    }

    var spinEnd = vid && !reduced ? 0.5 : 1;
    /* the wipe starts while the last part of the turn is still playing */
    var choreoStart = 0.34;
    /* The glide loop runs only while the stage is on screen. */
    var SPINS = 4, scrollP = 0, curSpin = 0, last = performance.now(), onStage = false, looping = false;
    function loop() {
      if (!onStage) { looping = false; return; }
      var now = performance.now();
      var dt = Math.min((now - last) / 1000, 0.05);
      last = now;
      curSpin += (scrollP * SPINS * Math.PI * 2 - curSpin) * (1 - Math.exp(-dt * 10));
      view.setSpin(curSpin);
      view.render(dt);
      requestAnimationFrame(loop);
    }
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (es) {
        onStage = es[es.length - 1].isIntersecting;
        if (onStage && !looping) { looping = true; last = performance.now(); requestAnimationFrame(loop); }
      }, { rootMargin: "200px" }).observe(outer);
    } else { onStage = looping = true; requestAnimationFrame(loop); }

    function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
    function easeOut(v) { return 1 - Math.pow(1 - v, 3); }

    gsap.set(header2, { yPercent: 42, autoAlpha: 0, scale: 0.92 });
    gsap.set(header2h, { yPercent: 0 });
    gsap.set(dividers, { scaleX: 0 });
    revealGroups.forEach(function (g) { gsap.set(g, { yPercent: 125, autoAlpha: 0 }); });

    /* Driven with gsap.set (no per-tick tween churn) so nothing snaps
       alignment mid-move. */
    /* Every beat is authored on a 0…1 track whose last one (the second
       tooltip) ends at 0.94; rescaling by 1/0.97 completes the WHOLE
       choreography at 97% of the pin. */
    /* Phones: the cream card sat with only its title for three screens before the
       tooltips came in, so the beats are packed closer and finish earlier. */
    var TM = mobile ? { end: 0.78, nudge: 0.40, div: 0.30, groups: [0.38, 0.52] }
                    : { end: 0.97, nudge: 0.62, div: 0.42, groups: [0.6, 0.78] };
    function choreo(raw) {
      var p = Math.min(raw / TM.end, 1);
      var e = easeOut(clamp01((p - 0.04) / 0.16));
      /* lift and fade only: an animated blur filter re-rasterised the heading on
         every scroll frame */
      if (header1) gsap.set(header1, { yPercent: -64 * e, autoAlpha: 1 - e });

      var m = clamp01((p - 0.12) / 0.15);
      gsap.set(mask, { clipPath: "circle(" + (m * 122).toFixed(2) + "% at 50% 50%)" });

      var t2 = easeOut(clamp01((p - 0.2) / 0.22));
      gsap.set(header2, { yPercent: 42 * (1 - t2), autoAlpha: t2, scale: 0.92 + 0.08 * t2 });
      /* once the tooltips are due, nudge the title up so it clears them */
      gsap.set(header2h, { yPercent: -16 * easeOut(clamp01((p - TM.nudge) / 0.28)) });

      gsap.set(dividers, { scaleX: clamp01((p - TM.div) / 0.16) });
      TM.groups.forEach(function (trg, i) {
        var r = easeOut(clamp01((p - trg) / 0.16));
        gsap.set(revealGroups[i], { yPercent: 125 * (1 - r), autoAlpha: r });
      });
    }
    choreo(0);

    ScrollTrigger.create({
      trigger: outer, start: "top top",
      /* The stage is 90vh (min 560px), not a full viewport, so it lets go of
         the screen when the wrapper's bottom reaches the STAGE's bottom edge —
         10vh before "bottom bottom". Ending there made the last tenth of the
         choreography play while the stage was already scrolling away. */
      end: function () { return "bottom top+=" + root.offsetHeight; },
      invalidateOnRefresh: true, pin: false, scrub: true,
      onUpdate: function (self) {
        /* With the spin clip the turn plays over 0…spinEnd of the pin; the wipe /
           title / tooltips choreography starts at choreoStart, overlapping its tail. */
        scrollP = Math.min(self.progress / spinEnd, 1);
        choreo(spinEnd < 1 ? Math.max(0, (self.progress - choreoStart) / (1 - choreoStart)) : self.progress);
      }
    });
  }

  /* ── orbit gallery ────────────────────────────────────────────────────────
     Ported from OrbitGallery in lib/sliders.tsx. Frames ride a tilted oval;
     the ring idles slowly, speeds up with the wheel, and hovering one frame
     scales it while dimming the rest. */
  function initOrbit(gallery) {
    if (reduced || !window.gsap) return;
    var cfg = { ovalWidthRatio: 0.36, ovalHeightRatio: 0.3, tiltAngle: -18, idleRotationSpeed: 0.035,
                scrollAcceleration: 0.0055, maxRotationSpeed: 2.5, speedEasing: 0.05,
                hoverScale: 1.1, idleZoom: 1.12, dimmedBrightness: 0.35 };
    var nodes = gallery.querySelectorAll(".sl-orbit-item");
    var items = Array.prototype.map.call(nodes, function (wrapper, i) {
      return { wrapper: wrapper, frame: wrapper.querySelector(".sl-orbit-frame"), image: wrapper.querySelector("img"),
               angle: (i / nodes.length) * Math.PI * 2 };
    });
    var rx = 0, ry = 0, tCos = 0, tSin = 0;
    function measure() {
      var b = gallery.getBoundingClientRect();
      rx = b.width * cfg.ovalWidthRatio; ry = b.height * cfg.ovalHeightRatio;
      var rad = cfg.tiltAngle * Math.PI / 180; tCos = Math.cos(rad); tSin = Math.sin(rad);
    }
    measure();
    function place(item, rotation) {
      var a = item.angle + rotation, ox = Math.cos(a) * rx, oy = Math.sin(a) * ry;
      item.wrapper.style.transform = "translate(" + (ox * tCos - oy * tSin) + "px, " + (ox * tSin + oy * tCos) + "px)";
    }
    items.forEach(function (it) { place(it, 0); });

    /* Phones: no idle drift and no hover. The ring's angle is the section's
       progress through the viewport, so it turns only while the page moves. */
    if (mobile && window.ScrollTrigger) {
      var turn = function (p) { var rad = p * Math.PI * 1.5; items.forEach(function (it) { place(it, rad); }); };
      ScrollTrigger.create({
        trigger: gallery, start: "top bottom", end: "bottom top", scrub: true,
        onUpdate: function (self) { turn(self.progress); },
        onRefresh: function (self) { measure(); turn(self.progress); }
      });
      return;
    }

    var ringRotation = 0, direction = 1, speed = cfg.idleRotationSpeed, px = -1, py = -1, hovered = null;
    gallery.addEventListener("wheel", function (e) {
      direction = e.deltaY > 0 ? 1 : -1;
      speed = Math.min(speed + Math.abs(e.deltaY) * cfg.scrollAcceleration, cfg.maxRotationSpeed);
    }, { passive: true });
    /* the pointer is kept in viewport coordinates: no layout read per event */
    gallery.addEventListener("mousemove", function (e) { px = e.clientX; py = e.clientY; });
    gallery.addEventListener("mouseleave", function () { px = py = -1; });
    window.addEventListener("resize", measure);
    var orbitOn = false, orbitLoop = false;
    new IntersectionObserver(function (es) {
      orbitOn = es[es.length - 1].isIntersecting;
      if (orbitOn && !orbitLoop) { orbitLoop = true; requestAnimationFrame(tick); }
    }, { rootMargin: "100px" }).observe(gallery);

    function applyHover(active) {
      items.forEach(function (item) {
        var isActive = item === active, isDimmed = !!active && !isActive;
        gsap.to(item.frame, { scale: isActive ? cfg.hoverScale : 1, duration: 1, ease: "expo.out", overwrite: true });
        gsap.to(item.image, { scale: isActive ? 1 : cfg.idleZoom, duration: 1, ease: "expo.out", overwrite: true });
        gsap.to(item.wrapper, { filter: "saturate(" + (isDimmed ? 0 : 1) + ") brightness(" + (isDimmed ? cfg.dimmedBrightness : 1) + ")",
                                duration: 1, ease: "expo.out", overwrite: true });
      });
    }

    var hoverEvery = 0;
    function tick() {
      if (!orbitOn) { orbitLoop = false; return; }
      speed += (cfg.idleRotationSpeed - speed) * cfg.speedEasing;
      ringRotation += speed * direction;
      var rad = ringRotation * Math.PI / 180;
      var under = null;
      /* hit-test every third frame, before this frame's writes: a hit test
         right after moving every frame forced a layout each time */
      if (px < 0) { if (hovered) { applyHover(null); hovered = null; } }
      else if (++hoverEvery % 3 === 0) {
        var el = document.elementFromPoint(px, py);
        var wrap = el && el.closest && el.closest(".sl-orbit-item");
        under = items.filter(function (it) { return it.wrapper === wrap; })[0] || null;
        if (under !== hovered) { applyHover(under); hovered = under; }
      }
      items.forEach(function (it) { place(it, rad); });
      requestAnimationFrame(tick);
    }
  }

  /* ── container scroll: tilted screen that levels out, stages cross-fade ───
     Numbers are the React build's (rotateX 20 -> 0, scale 1.05 -> 1, or
     0.7 -> 0.9 on phones, heading -100px). Progress matches framer's default
     for useScroll({ target }): 0 as the top meets the viewport bottom, 1 as the
     bottom meets the viewport top. The stages step through the 0.40-0.66 band. */
  function initContainerScroll(root) {
    var stage = root.querySelector("[data-cscroll-stage]");
    var head = root.querySelector("[data-cscroll-head]");
    var card = root.querySelector("[data-cscroll-card]");
    var layers = [].slice.call(root.querySelectorAll("[data-cscroll-layer]"));
    if (!stage || !card || !layers.length) return;

    if (reduced || !window.ScrollTrigger) {
      // No scrub: settle on the last stage, level and full size.
      layers.forEach(function (el, i) { el.style.opacity = i === layers.length - 1 ? 1 : 0; });
      return;
    }

    var clamp = gsap.utils.clamp;
    var mobile = window.innerWidth <= 768;
    window.addEventListener("resize", function () { mobile = window.innerWidth <= 768; });
    var last = layers.length - 1;

    function paint(p) {
      gsap.set(card, { rotationX: 20 * (1 - p), scale: mobile ? 0.7 + 0.2 * p : 1.05 - 0.05 * p });
      if (head) gsap.set(head, { y: -100 * p });
      // The card is centred in the viewport at p = 0.5 and fully in view from
      // ~0.4, so the stages step through 0.40-0.66. Each layer only ever fades
      // IN over the one beneath (which stays opaque), so there is never a
      // half-transparent overlap of two poses.
      var f = clamp(0, 1, (p - 0.4) / 0.26) * last;
      layers.forEach(function (el, i) {
        var d = f - i;                                   // <0: still to come, >0: already passed
        var w = d >= 0 ? 1 : clamp(0, 1, 1 + d);
        w = w * w * (3 - 2 * w);                         // smoothstep
        gsap.set(el, { opacity: w, scale: d < 0 ? 1 + 0.1 * -d : 1 + 0.18 * d });
      });
    }
    paint(0);
    ScrollTrigger.create({
      trigger: stage, start: "top bottom", end: "bottom top", scrub: true,
      onUpdate: function (self) { paint(self.progress); },
      onRefresh: function (self) { paint(self.progress); }
    });
  }

  /* ── box reveal: a rendered open of the real box, scrubbed by scroll ──────
     The sticky stage holds while the section scrolls; progress drives every
     loaded clip's currentTime (one seek in flight per clip, from the ticker)
     and fades each copy beat over its own [in, out] window. Two renders, one
     per box colour: only the chosen one is fetched, and a newly chosen clip
     fades in once it has landed on the current frame. */
  var BOX_KEY = "wango-box-colour";
  function initBoxScroll(root) {
    var vids = Array.prototype.slice.call(root.querySelectorAll("[data-bscroll-video]"));
    var swatches = Array.prototype.slice.call(root.querySelectorAll("[data-bscroll-swatch]"));
    var beats = Array.prototype.slice.call(root.querySelectorAll("[data-bscroll-beat]"));
    var bar = root.querySelector("[data-bscroll-bar]");
    if (!vids.length) return;
    var small = window.matchMedia("(max-width: 899px)").matches;
    var clamp = gsap.utils.clamp;
    var target = 0, current = vids[0].dataset.variant;
    var players = {};
    vids.forEach(function (v) { players[v.dataset.variant] = { video: v, loaded: false, ready: false }; });

    function show(variant) {
      vids.forEach(function (v) { v.classList.toggle("is-on", v.dataset.variant === variant); });
    }
    function mark(variant) {
      swatches.forEach(function (b) { b.setAttribute("aria-checked", b.dataset.bscrollSwatch === variant ? "true" : "false"); });
    }
    function load(variant) {
      var pl = players[variant];
      if (!pl || pl.loaded) return;
      pl.loaded = true;
      var v = pl.video;
      v.muted = true; v.preload = "auto";
      var src = (small && v.dataset.srcMobile) || v.dataset.src;
      v.addEventListener("loadedmetadata", function () {
        pl.ready = true;
        /* a detached muted video only decodes frames once it has played */
        var pr = v.play();
        if (pr && pr.then) pr.then(function () { v.pause(); }).catch(function () {});
        else v.pause();
      }, { once: true });
      (W.blobUrl ? W.blobUrl(src) : Promise.resolve(src)).then(function (u) { v.src = u; v.load(); });
    }
    function choose(variant, remember) {
      if (!players[variant]) return;
      current = variant;
      mark(variant);
      if (remember) { try { localStorage.setItem(BOX_KEY, variant); } catch (e) { /* private mode */ } }
      if (reduced || !window.ScrollTrigger) { show(variant); return; }
      load(variant);
      var pl = players[variant];
      /* keep the old colour on screen until the new clip sits on the same frame */
      (function wait() {
        if (current !== variant) return;
        var v = pl.video;
        if (pl.ready && v.readyState >= 2 && !v.seeking && Math.abs(v.currentTime - target) < 0.05) show(variant);
        else requestAnimationFrame(wait);
      })();
    }
    swatches.forEach(function (b) {
      b.addEventListener("click", function () { choose(b.dataset.bscrollSwatch, true); });
    });

    var saved = null;
    try { saved = localStorage.getItem(BOX_KEY); } catch (e) { /* private mode */ }
    if (saved && players[saved]) current = saved;

    if (reduced || !window.ScrollTrigger) {
      vids.forEach(function (v) { if (v.dataset.posterEnd) v.poster = v.dataset.posterEnd; });
      beats.forEach(function (el) { el.style.opacity = 1; el.style.transform = "none"; });
      mark(current); show(current);
      return;
    }

    gsap.ticker.add(function () {
      vids.forEach(function (v) {
        var pl = players[v.dataset.variant];
        if (!pl.ready || !v.duration || v.seeking) return;
        var t = Math.min(target, v.duration - 0.04);
        if (Math.abs(v.currentTime - t) > 0.012) v.currentTime = t;
      });
    });

    /* edges[i] = where beat i takes over; overlapping in/out settings meet at their midpoint */
    var edges = beats.map(function (el, i) {
      if (i === 0) return 0;
      var prev = parseFloat(beats[i - 1].dataset.out), cur = parseFloat(el.dataset.in);
      return (prev + cur) / 2;
    });
    edges.push(beats.length ? Math.max(1, parseFloat(beats[beats.length - 1].dataset.out)) : 1);
    function paint(p) {
      target = clamp(0, 1, p) * 5;   /* seconds; each clip clamps to its own length */
      vids.forEach(function (v) { if (v.duration) target = Math.min(target, clamp(0, 1, p) * (v.duration - 0.04)); });
      if (bar) bar.style.transform = "scaleX(" + p.toFixed(4) + ")";
      beats.forEach(function (el, i) {
        var a = edges[i], b = edges[i + 1], f = 0.05;
        /* neighbours hand over at one shared point: the old line is gone before the new one arrives */
        var vin = i === 0 ? 1 : clamp(0, 1, (p - a) / f);
        var vout = b >= 1 ? 1 : clamp(0, 1, (b - p) / f);
        var v = Math.min(vin, vout);
        el.style.opacity = v;
        el.style.transform = "translateY(" + ((1 - v) * (p < a + f ? 14 : -14)).toFixed(1) + "px)";
        el.style.pointerEvents = v > 0.5 ? "auto" : "none";
      });
    }
    mark(current); show(current);
    (W.whenNear || function (e, f) { f(); })(root, function () { load(current); });
    paint(0);
    ScrollTrigger.create({
      trigger: root, start: "top top", end: "bottom bottom", scrub: true,
      onUpdate: function (self) { paint(self.progress); },
      onRefresh: function (self) { paint(self.progress); }
    });
  }

  var MAP = [["[data-boxhero]", initBoxHero], ["[data-explode]", initExplode], ["[data-sound]", initSound],
             ["[data-scroll-reveal]", initScrollReveal], ["[data-orbit]", initOrbit], ["[data-cscroll]", initContainerScroll], ["[data-bscroll]", initBoxScroll]];
  function boot(scope) {
    MAP.forEach(function (pair) {
      (scope || document).querySelectorAll(pair[0]).forEach(function (el) {
        if (el.dataset.wangoReady) return;
        el.dataset.wangoReady = "1";
        pair[1](el);
      });
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { boot(); });
  else boot();
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
})();
